import type { ChipProps as MuiCheckboxProps } from '@mui/material/Chip';

import MuiChip from '@mui/material/Chip';

export interface ChipProps extends MuiCheckboxProps {
  size?: 'medium' | 'small';
}

export const Chip = ({ size = 'small', ...props }: ChipProps) => {
  return <MuiChip {...props} />;
};
